import { t } from "@lingui/macro"
import { i18n } from "@lingui/core"

export const getShipDirectionLabels = () => ({
    stern: t`STERN`,
    bow: t`BOW`,
})
export const labelDeckOfTotal = (deckNumber: number, totalDecksNumber: number) =>
    `${i18n._(t({ id: "deck" }))} ${deckNumber} ${i18n._(t({ id: "count-separator-xx-of-xx" }))} ${totalDecksNumber}`
